<template>
  <v-main class="document pt-5" style="margin: 0 auto">
    <v-container v-if="!loading" class="container-print">
      <div class="row px-6 pt-6">
        <div class="pl-0">
          <h4 class="row ma-0 primary--text text-bold">{{ fields.celebration && fields.celebration.name }}</h4>
          <h1 class="primary--text">{{ fields.customer && fields.customer.name }}</h1>
        </div>
        <v-spacer></v-spacer>
        <div class="text-right primary--text">
          <img src="@/assets/logo-heppi.png" srcset="@/assets/logo-heppi@2x.png 2x" style="height: 40px" />
          <br>
          <h3>{{ documentName }}</h3>
        </div>
      </div>
      <div v-if="reportSections.info" class="row px-3 pt-2">
        <div class="col-8 mr-auto">
          <div class="row">
            <div class="col">
              <small>CPF/CNPJ</small>
              <br>
              <b>{{ fields.customer.person_document | document }}</b>
            </div>
            <div class="col">
              <small>Telefone</small>
              <br>
              <b>{{ fields.customer.phone_number | phone_number }}</b>
            </div>
          </div>
          <small>E-mail</small>
          <br>
          <b>{{ fields.customer.email }}</b>
        </div>
        <div class="col-4 mr-auto">
          <small>Dia de pagamento</small>
          <br>
          <b>{{ (fields.payment_day === 0) ? 'Último dia' : 'Dia ' + fields.payment_day }}</b>
          <br>
          <small>Entrou em</small>
          <br>
          <b>{{ fields.created_at | moment('DD/MM/YYYY hh:mm:ss') }}</b>
        </div>
      </div>
      <div v-if="reportSections.fundraisings" class="px-3 pt-6">
        <h3 class="primary--text">Arrecadações</h3>
        <v-divider class="mb-3" />
        <fundraisings :participantId="id" :joineds="fields.fundraisings" />
      </div>
      <div v-if="reportSections.paid" class="px-3 pt-6">
        <h3 class="primary--text">Faturas pagas</h3>
        <v-divider class="mb-3" />
        <invoices
          v-if="fields.customer && fields.customer.id && fields.celebration && fields.celebration.id"
          status="paid"
          :customerId="fields.customer && fields.customer.id"
          :celebrationId="fields.celebration && fields.celebration.id"
        />
      </div>
      <div v-if="reportSections.pending" class="px-3 pt-6">
        <h3 class="primary--text">Faturas em aberto</h3>
        <v-divider class="mb-3" />
        <invoices
          v-if="fields.customer && fields.customer.id && fields.celebration && fields.celebration.id"
          status="pending"
          :customerId="fields.customer && fields.customer.id"
          :celebrationId="fields.celebration && fields.celebration.id"
        />
      </div>
      <div v-if="reportSections.next" class="px-3 pt-6">
        <h3 class="primary--text">Próximas faturas</h3>
        <v-divider class="mb-3" />
        <next-invoices :participantId="id" :joineds="fields.fundraisings" />
      </div>
      <div v-if="reportSections.notes" class="px-3 pt-6">
        <h3 class="primary--text">Observações</h3>
        <v-divider class="mb-3" />
        <notes reference="participant" :participantId="id" />
      </div>
      <div class="pt-4 text-right">
        <i class="caption">Documento gerado no dia {{ now }}</i>
      </div>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import Notes from '@/components/Print/Notes'
import Invoices from '@/components/Print/Invoices'
import Fundraisings from '@/components/Print/Fundraisings'
import NextInvoices from '@/components/Print/NextInvoices'

export default {
  name: 'fundraisingForm',
  components: {
    AppLoading,
    Notes,
    Invoices,
    Fundraisings,
    NextInvoices
  },
  props: ['id'],
  data: () => ({
    loading: false,
    documentName: 'Ficha Financeira',
    fields: {
      customer: {
        id: '',
        name: '',
        email: '',
        phone_number: '',
        person_document: ''
      },
      celebration: {
        id: '',
        name: ''
      },
      payment_day: 0,
      role: '',
      created_at: '',
      fundraisings: []
    },
    reportSections: {
      info: false,
      fundraisings: false,
      paid: false,
      pending: false,
      next: false,
      notes: false
    },
    now: ''
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      let vue = this
      vue.loading = true
      axios.get('participants/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (response.data[key]) vue.fields[key] = response.data[key]
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  },
  async created () {
    if (this.id) {
      const queryData = this.$route.query || {}
      this.documentName = queryData.title || 'Ficha Financeira'
      this.reportSections.info = !!queryData.info
      this.reportSections.fundraisings = !!queryData.fundraisings
      this.reportSections.paid = !!queryData.paid
      this.reportSections.pending = !!queryData.pending
      this.reportSections.next = !!queryData.next
      this.reportSections.notes = !!queryData.notes
      this.getData()
    } else {
      this.$router.go(-1)
    }

    this.now = this.$moment().format('DD/MM/YYYY HH:mm')
  }
}
</script>

<style>
.container-print {
  padding: 30px;
}

@media print {
  .container-print {
    padding: 0;
    margin-top: -0.5cm;
    max-width: 28cm;
  }
}

@page { margin: 1cm 0 !important } /* All margins set to 2cm */

</style>
